module.exports = "bundles/3b0106fb54bcf7ad8be53ee5c352a73a.png";


//////////////////
// WEBPACK FOOTER
// ../src/media/pie-charts/pie-chart-30.png
// module id = 130
// module chunks = 0